// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"968988df","328":"76d17b87","415":"2ceb3ac3","454":"8b2273f8","553":"6eac018b","603":"873ad554","658":"145e18b0","721":"d7dc30a9","892":"3fe3ae02"}[chunkId] + ".chunk.js";
};